/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualitySectionConfig } from '../../models/quality-section-config';
import { QualitySectionConfigDto } from '../../models/quality-section-config-dto';

export interface CreateQualitySectionConfig$Params {
  body: QualitySectionConfigDto;
}

export function createQualitySectionConfig(
  http: HttpClient,
  rootUrl: string,
  params: CreateQualitySectionConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<QualitySectionConfig>> {
  const rb = new RequestBuilder(rootUrl, createQualitySectionConfig.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QualitySectionConfig>;
    })
  );
}

createQualitySectionConfig.PATH = '/admin/quality-section-config';
